import { render, staticRenderFns } from "./ModalWindow.vue?vue&type=template&id=689e4012&scoped=true&lang=pug"
import script from "./ModalWindow.vue?vue&type=script&lang=ts"
export * from "./ModalWindow.vue?vue&type=script&lang=ts"
import style0 from "./ModalWindow.vue?vue&type=style&index=0&id=689e4012&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689e4012",
  null
  
)

export default component.exports